// Backend of atc.coone.dev (existing Node service): accounts, progress, leaderboard and Piper TTS.
// The game also runs without it (guest mode, local saves) – e.g. in development or when the server is down.

export interface User { username: string; progress?: Record<string, unknown> }
export type ApiState = 'unknown' | 'available' | 'offline';

export class ApiError extends Error { constructor(message: string, readonly status: number) { super(message); } }

let state: ApiState = 'unknown';
export const apiState = (): ApiState => state;

async function call<T>(path: string, method = 'GET', body?: unknown): Promise<T> {
  let res: Response;
  try {
    res = await fetch('/api/' + path, { method, credentials: 'same-origin', headers: body ? { 'Content-Type': 'application/json' } : {}, body: body ? JSON.stringify(body) : undefined });
  } catch {
    state = 'offline';
    throw new ApiError('Server nicht erreichbar', 0);
  }
  const type = res.headers.get('content-type') ?? '';
  // a static dev server answers unknown paths with index.html → no backend
  if (!type.includes('json') && !path.startsWith('tts')) { state = 'offline'; throw new ApiError('Kein Spielserver verfügbar', 404); }
  state = 'available';
  let data: { error?: string } & Record<string, unknown> = {};
  try { data = await res.json(); } catch { /* empty */ }
  if (!res.ok) throw new ApiError(data.error ?? `Fehler ${res.status}`, res.status);
  return data as T;
}

export const api = {
  me: () => call<{ user: User }>('me'),
  login: (username: string, password: string) => call<{ user: User }>('login', 'POST', { username, password }),
  register: (username: string, password: string) => call<{ user: User }>('register', 'POST', { username, password }),
  logout: () => call<unknown>('logout', 'POST'),
  saveProgress: (progress: Record<string, unknown>) => call<{ user: User }>('progress', 'PUT', { progress }),
  leaderboard: () => call<{ rows: { username: string; xp: number }[] }>('leaderboard'),
};
